








































































import { Component, Prop, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';

import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { Severity } from '@sentry/types';

@Component
export default class PatientDelete extends MixinDialog {
  @Prop({ default: null }) private patient?: TEntity<TPatient>;

  dialog = false;
  status: any = {
    success: false,
    loading: false,
    error: null,
  };
  internalPatient: TEntity<TPatient> | null | undefined = null;

  get validPatient(): TEntity<TPatient> | null {
    return this.patient ? this.patient! : this.internalPatient!;
  }

  async remove(): Promise<void> {
    // Avoid duplication of the process
    // Check a patient id exist
    if (!this.validPatient!._id) return;

    try {
      // Reset flags
      this.status.success = false;
      this.status.error = null;
      // Set 'pending' flag
      this.status.pending = true;
      // Try to delete patient
      await this.$pdc.entities!.patients.remove(this.validPatient!._id);
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Patient Deleted', {
        patientId: this.validPatient!._id,
      });
      // Set 'success' flag
      this.status.success = true;
      // Send global event
      this.$pdc.bus!.emit('patient:removed', this.validPatient!._id);

      if (this.$route.name !== 'patients') {
        await this.$router.push({
          name: 'patients',
        });
      }
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('Patient Deleted', e, {
        patientId: this.validPatient!._id,
      });
      // Set 'error' flag
      this.status.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.status.pending = false;
    }
  }

  closeDialog() {
    this.status.success = false;
    this.status.pending = false;
    this.status.error = null;
    this.close();
  }

  open(patient?: TEntity<TPatient>) {
    this.internalPatient = patient;
    this.dialog = true;
  }

  mounted() {
    if (this.listenBus) {
      this.$pdc.bus!.on('patient:removed', this.open);
    }
  }
  beforeDestroy() {
    if (this.listenBus) {
      this.$pdc.bus!.off('patient:removed', this.open);
    }
  }
}
